export function* zip(arrays: Array<Array<any>>) {
  const iterators = arrays.map((a) => a[Symbol.iterator]());
  while (true) {
    const results = iterators.map((it) => it.next());
    if (results.some((r) => r.done)) return;
    yield results.map((r) => r.value);
  }
}
